<template>
  <div class="ui left aligned container">
    <vuetable ref="vuetable"
              api-url="/tieba"
              :fields="fields"
              :sort-order="sortOrder"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
    <div>
      <br/>
      <a href="http://tieba.baidu.com/f?kw=%E6%9D%A8%E8%B6%85%E8%B6%8A&fr=index&red_tag=g0311454745" target="_blank">杨超越吧</a>
      &nbsp;&nbsp;
      <a href="https://baike.baidu.com/item/%E6%9D%A8%E8%B6%85%E8%B6%8A" target="_blank">杨超越百科</a>
    </div>
    <div class="ui hidden divider"></div>
    <div class="row">
      <date-picker range valueType="format" @clear="range=[]" v-model="range"></date-picker>
      <button class="ui load button" @click="load">Load</button>
    </div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>
<style>
.ui.load.button {
  margin-left: 12px;
}
</style>
<script>
  import Vuetable from '../table/Vuetable.vue'
  import VuetablePagination from '../table/VuetablePagination.vue'
  import axios from 'axios'
  import ECharts from 'vue-echarts'
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'Tieba',
    components: {
      Vuetable,
      VuetablePagination,
      DatePicker,
      'v-chart': ECharts,
    },
    data () {
      return {
        fields: [
          {name: 'date', title: '日期', sortField: 'date'},
          {name: 'subjects', title: '主题'},
          {name: 'comments', title: '帖子'},
          {name: 'members', title: '成员'},
          {name: 'signCount', title: '签到', sortField: 'signCount'},
          {name: 'rank', title: '签到排名', sortField: 'rank'},
        ],
        size: 10,
        page: 0,
        range: [],
        options: null,
        sortOrder: [
          {
            field: 'date',
            direction: 'desc'
          }
        ]
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        if (page === 'prev') {
          this.page--
        } else if (page === 'next') {
          this.page++
        } else {
          this.page = parseInt(page)
        }
        this.range = [];
        this.load();
        this.$refs.vuetable.changePage(page)
      },
      load: function () {
        let api = `/tieba/chart?size=${this.size}&page=${this.page}`
        if (this.range.length === 2) {
          api = `/tieba/chart?start=${this.range[0]}&end=${this.range[1]}`
        }
        axios.get(api).then(response => {
          this.options =
              {
                title: {
                  text: '增幅'
                },
                tooltip: {
                  trigger: 'axis'
                },
                legend: {
                  data: ['主题', '帖子', '成员', '签到']
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                xAxis: {
                  type: 'time'
                },
                yAxis: {
                  type: 'value'
                },
                series: [
                  {
                    name: '主题',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.subjects])
                  },
                  {
                    name: '帖子',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.comments])
                  },
                  {
                    name: '成员',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.members])
                  },
                  {
                    name: '签到',
                    type: 'line',
                    data: response.data.map(e => [e.date, e.signCount])
                  },
                ]
              };
        });
      }
    }
  }
</script>
